import { environment } from '@env/environment'
import { type CityProfile } from '@core/city-profile/city-profile'
import { kLyonProfile } from '@core/city-profile/profiles/lyon.profile'
import { kLisbonProfile } from '@core/city-profile/profiles/lisbon.profile'
import { kTorinoProfile } from '@core/city-profile/profiles/torino.profile'

const env: any = environment

// every demo city profile known to the app, keyed by its id
const kProfilesById: Record<string, CityProfile> = {
  lyon: kLyonProfile,
  lisbon: kLisbonProfile,
  torino: kTorinoProfile,
}

// the demo city selected by the build (environment.demoCity), defaulting to Lyon
// so non-demo builds keep the historical behaviour
export const ENV_DEMO_CITY: string = (typeof env.demoCity === 'string' && env.demoCity !== '') ? env.demoCity : 'lyon'

// the active city profile, resolved once from the environment
export const CITY_PROFILE: CityProfile = kProfilesById[ENV_DEMO_CITY] ?? kLyonProfile
